export default __webpack_public_path__ + "static/media/main-logo.4c197f43.png";